import {InputFormatType} from "../models/inputFormatType";
import toFixed from "../../../common/helpers/toFixed";

const numericValidationWithOptionalDecimalPlaces = (value: any, element : any): string => {
  let result = value;
  if (element.format_type === InputFormatType.Numeric || element.format_type === InputFormatType.Currency) {
    result = isNaN(parseFloat(value)) ? null : parseFloat(value).toString();
    if (isFinite(parseInt(element.decimal_places, 10))) {
      result = toFixed(value, element.decimal_places);
    }
  }
  return result;
};

export default numericValidationWithOptionalDecimalPlaces;
